export default function CategoryNav({ categories, activeCategory, onCategoryClick }) {
  return (
    <div className="sticky top-[180px] md:top-[220px] z-30 bg-white border-b shadow-sm">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center gap-2 overflow-x-auto py-3 scrollbar-hide">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategoryClick(category.id)}
              className={`
                px-4 py-2 rounded-full whitespace-nowrap text-sm font-medium transition-colors flex-shrink-0
                ${activeCategory === category.id
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }
              `}
            >
              {category.name}
              <span className="ml-2 text-xs opacity-75">
                ({category.items.length})
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
